import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import Keycloak from 'keycloak-js';
import { environment } from '../environments/environment';
import { KEYCLOAK } from './keycloak.token';
import { authInterceptor } from './auth.interceptor';
import { appRoutes } from './app.routes';
import { AuthService } from './auth.service';
import { bootAuth } from './auth-boot';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(appRoutes, withComponentInputBinding()),
    { provide: KEYCLOAK, useValue: new Keycloak(environment.keycloak) },
    // Route guards read the identity, so a deep link or refresh must not race the fetch.
    provideAppInitializer(() =>
      bootAuth(
        inject(KEYCLOAK),
        inject(AuthService),
        window.location,
        environment.kcIdentityProvider,
      ),
    ),
  ],
};
